// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__5wDGG","head":"styles_head__YoWyU","buttonWrapper":"styles_buttonWrapper__uwVWy","button":"styles_button__-xKku","buttonTabs":"styles_buttonTabs__1sCee"};